module.exports = __webpack_public_path__ + "static/media/SL 6.22dd6a0f.mp3";